<template>
    <b-form>
      <vue-loading :active="isLoading" loader="bars" :is-full-page="false"></vue-loading>
      <b-form-group
        description="Enter the campaign title."
        label="Campaign Title"
        :label-cols="3"
        :horizontal="true">
        <b-form-input v-model="campaign.title" type="text"></b-form-input>
        <validation-errors :errors="campaign.errors" field="title"></validation-errors>
      </b-form-group>
      <b-form-group
        description="Enter the campaign subject."
        label="Campaign Subject"
        :label-cols="3"
        :horizontal="true">
        <b-form-input v-model="campaign.subject" type="text"></b-form-input>
        <validation-errors :errors="campaign.errors" field="subject"></validation-errors>
      </b-form-group>
      <b-form-group
        v-if="'edit' === type"
        description="Status"
        label="Status"
        :label-cols="3"
        :horizontal="true"
      >
        <app-btn :text="campaign.status"/>
      </b-form-group>
      <b-form-group
        v-if="'edit' === type"
        description="Listings"
        label="Listings"
        :label-cols="3"
        :horizontal="true"
      >
        <ul class="list-unstyled">
          <li v-for="listing in campaign.listings" :key="'camp-form-list-'+listing.listing.id"> {{listing.listing.name}}</li>
        </ul>
      </b-form-group>
      <b-form-group
        v-if="'edit' === type"
        description="Send At"
        label="Send At"
        :label-cols="3"
        :horizontal="true"
      >
        {{campaign.sendAt|moment("DD/MM/YYYY")}}
      </b-form-group>
      <campaign-actions
        v-if="'edit' === type"
        :campaign="campaign"
        @click="onCampaignActionClick"
        @updated="onCampaignUpdated"
      />
    </b-form>
</template>

<script>
    import ValidationErrors from "../../base/ValidationErrors";
    import {Campaign} from "@/models/NewsLetter/Campaign";
    import AppBtn from "@/components/base/AppBtn";
    import CampaignActions from "@/components/newsletter/Campaign/CampaignActions";
    import VueLoading from "vue-loading-overlay/src/js/Component";

    export default {
      name: "CampaignForm",
      components: {
        CampaignActions,
        AppBtn,
        ValidationErrors,
        VueLoading,
      },
      data() {
        return {
          isLoading: false
        }
      },
      props: {
        campaign: {
          type: Object,
          default: new Campaign(),
        },
        type: {
          type: String,
          default: 'view',
        },
      },
      methods: {
        onCampaignActionClick() {
          this.isLoading = true;
        },
        onCampaignUpdated(campaign) {
          this.isLoading = false;
          this.campaign = campaign;
        },
      }
    }
</script>
